import { render, staticRenderFns } from "./PostDouble600Arm1976-F.vue?vue&type=template&id=5bfcb9ec"
import script from "./PostDouble600Arm1976-F.vue?vue&type=script&lang=js"
export * from "./PostDouble600Arm1976-F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports